// extracted by mini-css-extract-plugin
module.exports = {"web-root":"web-root___3ZMkz","web-root-isFold":"web-root-isFold___1SZi2","web-icon":"web-icon___3Pbcf","web-list":"web-list___2B4TF","norem-list-item":"norem-list-item___3GWHN"};